import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {CommentFolderService} from "../../../../../../../core/ek-e-commerce/ek-services/comment-folder.service";
import {ActivatedRoute, Router} from "@angular/router";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {CommentFolderModel} from "../../../../../../../core/ek-e-commerce/ek-models/CommentFolder.model";
import {AddCommentComponent} from "./add-comment/add-comment.component";
import {
    ConfigurationsDatasource
} from "../../../../../../../core/ek-e-commerce/ek-data-sources/configuration.datasource";
import {LayoutUtilsService, MessageType} from "../../../../../../../core/_base/crud";
import {BehaviorSubject, Observable, of} from "rxjs";
import {Location} from "@angular/common";
import {FoldersService} from "../../../../../../../core/ek-e-commerce/ek-services/folders.service";
import {Folder} from "../../../../../../../../../../ek-guichet/src/app/Models/folder";


@Component({
    selector: 'kt-folder-step-eight',
    templateUrl: './folder-step-eight.component.html',
    styleUrls: ['./folder-step-eight.component.scss']
})
export class FolderStepEightComponent implements OnInit {
    pageSize = 10;
    pageIndex = 1;
    page: number = 1;
    comments: CommentFolderModel[] = [];

    idOrder = 0;
    idFolder = 0;

    dataSource: ConfigurationsDatasource;
    totalComments = 100;
    currentPageIndex = 0;
    test = false;
    index: number;
    commentSubject$ = new BehaviorSubject<CommentFolderModel[]>([]);
    readonly CommentsObj$ = this.commentSubject$.asObservable();

    public folderRequestNumber$: Observable<string>;

    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

    title: any;
    role: string [] = [];
    currentRole: string = '';
    folder: Folder;
    user: any;



    constructor(public dialog: MatDialog,
                private commentService: CommentFolderService,
                private route: ActivatedRoute,
                private router: Router,
                private location: Location,
                private folderService: FoldersService,
                private layoutUtilsService: LayoutUtilsService) {
        this.user = JSON.parse(localStorage.getItem('currentUser'));
        this.currentRole = this.user.roles;
    }

    ngOnInit(): void {

        this.route.paramMap.subscribe(params => {
            this.idFolder = Number(params.get('idFolder'));
            this.role = JSON.parse(localStorage.getItem('currentUser')).roles;
            this.title = this.route.snapshot.data['title'];
        });


        this.commentSubject$.subscribe(change => {
            this.comments = change;
        });

        this.getComments();

        this.folderService.getFolderById(this.idFolder).subscribe({
            next: (folder) => {
                this.folder = folder;
            },
            error: () => {
                console.log('error in getting folder by id ...')
            }
        });

        this.getFolderById();

    }


    getComments() {
        this.commentService.getAllComments(this.idFolder).subscribe(data => {
            this.comments = data.content;
            this.commentSubject$.next(data.content);
        });
    }

    back() {
        this.location.back();
    }

    getFolderById() {
        this.folderService.getFolderById(this.idFolder).subscribe({
            next: (folder) => {
                this.folderRequestNumber$ = of(folder.requestNumber);
            }
        });
    }

    isPossibleToAddComment() {

        if (this.currentRole === 'ROLE_CONFORMITY_MANAGER'
            || this.currentRole === 'ROLE_GUEST_ADMIN') {
            return false;
        }

        if (this.currentRole === 'ROLE_CREDIT_ANALYST_EK') {
            return (this.folder?.folderState === 'EK_BANK_RESERVE'
                || this.folder?.folderState === 'EK_FOLDER_IN_PROGRESS'
                || this.folder?.folderState === 'EK_FOLDER_CREATED');
        }

        if (this.currentRole === 'ROLE_POS_EK') {
            return (this.folder?.folderState === 'EK_FOLDER_CREATED' || this.folder?.folderState === 'EK_FOLDER_RESERVE');
        }

        return true;
    }
    isPossibleToEditComment(comment: CommentFolderModel) {

        if (this.currentRole === 'ROLE_CONFORMITY_MANAGER'
            || this.currentRole === 'ROLE_GUEST_ADMIN') {
            return false;
        }

        if (this.currentRole === 'ROLE_POS_EK'){
            return ((comment.email === this.user.email) && (this.folder.folderState === 'EK_FOLDER_CREATED' || this.folder.folderState === 'EK_FOLDER_RESERVE'))
        }

        if (this.currentRole === 'ROLE_CREDIT_ANALYST_EK'){
            return ((comment.email === this.user.email) && (this.folder.folderState === 'EK_BANK_RESERVE' || this.folder.folderState === 'EK_FOLDER_IN_PROGRESS' || this.folder?.folderState === 'EK_FOLDER_CREATED'));
        }

        if (this.currentRole === 'ROLE_BANKER_EK') {
            return comment.email === this.user.email;
        }

        return true;
    }

    isPossibleToDeleteComment(comment: CommentFolderModel) {


        if (this.currentRole === 'ROLE_SUPERADMIN'
            || this.currentRole === 'ROLE_ADMIN' ) {
            return true;
        }

        return false;

        // if (this.currentRole === 'ROLE_BANKER_EK'
        //     || this.currentRole === 'ROLE_CREDIT_ANALYST_EK'
        //     || this.currentRole === 'ROLE_POS_EK') {
        //     return false;
        // }
        //
        // return true;


    }

    translateRole(role) {
        switch (role) {
            case 'ROLE_SUPERADMIN':
                return 'Super Administrateur';
            case 'ROLE_ADMIN':
                return 'Administrateur';
            case 'ROLE_POS_EK':
                return 'POS (Point de vente)';
            case 'ROLE_CREDIT_ANALYST_EK':
                return 'Credit Analyst';
            case 'ROLE_GUEST_ADMIN':
                return 'Administrateur invité';
            case 'ROLE_BANKER_EK':
                return 'Banquier';
            default:
                return '/'
        }
    }

    pageChanged(event: PageEvent) {
        this.pageSize = event.pageSize;
        this.currentPageIndex = event.pageIndex;
    }

    openDialogEdit(comment: CommentFolderModel) {

        const dialogRef = this.dialog.open(AddCommentComponent, {
                width: '480PX',
                data: {
                    comment: comment,
                    editMode: true,
                    idFolder: this.idFolder,
                    title: this.title,
                    finalCheck: '',
                    documentGender: '',
                    documentTitle: '',
                    documentId: '',
                    state: '',
                    folderState: this.folder.folderState,
                }
            }
        );

        dialogRef.afterClosed().subscribe(result => {

            if (result) {

                const index = this.comments.findIndex(cmnt => cmnt.id === comment.id);

                this.comments[index] = result;

                const message = `commentaires modifiés avec succès !`;
                this.layoutUtilsService.showActionNotification(
                    message,
                    MessageType.Update,
                    5000,
                    true,
                    true
                );
                this.commentSubject$.next(this.comments);
            }
        });


    }


    openDialog(): void {
        const dialogRef = this.dialog.open(AddCommentComponent, {
                width: '480PX',
                data: {
                    editMode: false,
                    idFolder: this.idFolder,
                    title: this.title,
                    finalCheck: '',
                    documentGender: '',
                    documentTitle: '',
                    documentId: '',
                    state: '',
                    folderState: this.folder.folderState,
                }
            }
        );

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.id) {

                this.comments.push(result);

                this.commentSubject$.next(this.comments);

                const message = `commentaires ajoutés avec succès !`;
                this.layoutUtilsService.showActionNotification(
                    message,
                    MessageType.Update,
                    5000,
                    true,
                    true
                );

            }

        });
    }

    deleteComment(id: number) {

        this.commentService.deleteCommentById(id).subscribe(data => {
            if (data.code == 0) {
                this.test = true;
                this.layoutUtilsService.showActionNotification('Le commentaire a été supprimé avec succès');
            }
        });
        this.comments = this.comments.filter(comment => comment.id !== id);
        this.commentSubject$.next(this.comments);

    }


}
